export function buildSiteInABoxPdfFilename(item) {
    const slug = (item.customer_name || "site-in-a-box")
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase();
    return `${slug || "site-in-a-box"}-${item.id}.pdf`;
}
/** Call synchronously inside a click handler before awaiting the signed URL. */
export function openPdfPreviewTab() {
    return window.open("about:blank", "_blank");
}
/**
 * Downloads or opens a PDF from a URL (e.g. S3 presigned).
 * Pass `fallbackWindow` from `openPdfPreviewTab()` when the URL is fetched asynchronously.
 */
export async function downloadPdfFromUrl(url, filename, options) {
    const { fallbackWindow } = options ?? {};
    const showInWindow = (href) => {
        if (fallbackWindow && !fallbackWindow.closed) {
            fallbackWindow.location.href = href;
            return;
        }
        window.open(href, "_blank", "noopener,noreferrer");
    };
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Failed to fetch PDF: ${response.status}`);
        }
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        // May be ignored after async, but harmless when a preview tab is used.
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showInWindow(blobUrl);
        window.setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    }
    catch {
        showInWindow(url);
    }
}
